import { render, staticRenderFns } from "./Pivot.vue?vue&type=template&id=e65ec18a&scoped=true&"
import script from "./Pivot.vue?vue&type=script&lang=ts&"
export * from "./Pivot.vue?vue&type=script&lang=ts&"
import style0 from "./Pivot.vue?vue&type=style&index=0&id=e65ec18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65ec18a",
  null
  
)

export default component.exports